var _rect, _circle, _line, _rect2, _path, _line2, _circle2, _rect3, _line3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolDigitSubstitution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 12,
    width: 64,
    height: 76,
    rx: 6,
    fill: "#F9907B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 30,
    r: 8,
    fill: "#C75E5A"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 30,
    x2: 53,
    y2: 30,
    stroke: "#FAC1B5",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 22,
    width: 16,
    height: 16,
    rx: 2,
    fill: "#FAC1B5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 42L43 58H27Z",
    fill: "#C75E5A"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 50,
    x2: 53,
    y2: 50,
    stroke: "#FAC1B5",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 50,
    r: 8,
    fill: "#FAC1B5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 62,
    width: 16,
    height: 16,
    rx: 2,
    fill: "#C75E5A"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 70,
    x2: 53,
    y2: 70,
    stroke: "#FAC1B5",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65 62L73 78H57Z",
    fill: "#FAC1B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolDigitSubstitution);
export default __webpack_public_path__ + "static/media/SymbolDigitSubstitution.aeefe79def406c2a9e1a286ee4e1504d.svg";
export { ForwardRef as ReactComponent };